// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3 } from "../common";
import { UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3 } from "../users";
export var BatchDeleteItemsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.item) {
            wireFormat.item = message.item.map(function(i) {
                return ItemWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var CreateOrganizationRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.image) {
            wireFormat.image = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.image);
        }
        return wireFormat;
    }
};
var defaultCreateOrganizationResponse = {
    organizationId: 0
};
export var CreateOrganizationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateOrganizationResponse, wireFormat);
        return message;
    }
};
export var GetOrganizationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ItemWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultOrganization = {
    name: "",
    thumbnailImageUrl: "",
    id: 0,
    slug: "",
    featuredMembers: [],
    memberCount: 0
};
export var OrganizationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOrganization, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.featuredMembers) {
            message.featuredMembers = wireFormat.featuredMembers.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.membershipType) != undefined) {
            message.membershipType = OrganizationMembershipTypeWireFormat3.fromJson(wireFormat.membershipType);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentState) != undefined) {
            message.contentState = ContentStateWireFormat3.fromJson(wireFormat.contentState);
        }
        return message;
    }
};
export var ContentState;
(function(ContentState) {
    ContentState["UNSPECIFIED"] = "unspecified";
    ContentState[// Awaiting abuse classification. This exists as a non-visible state prior to
    // classification.
    "PENDING_CLASSIFICATION"] = "pendingClassification";
    ContentState[// Publicly viewable, although access may be restricted outside of its content
    // state.
    "PUBLISHED"] = "published";
    ContentState[// Quarantined by an admin or by the system. This means that the content is
    // only visible to the user and admins, however users are able to toggle their
    // content out of this state.
    "TEMPORARILY_QUARANTINED"] = "temporarilyQuarantined";
    ContentState[// Quarantined by an admin or by the system, the user cannot toggle their
    // content's state back to public.
    "PERMANENTLY_QUARANTINED"] = "permanentlyQuarantined";
    ContentState[// Deleted by the user.
    "USER_DELETED"] = "userDeleted";
    ContentState[// Deleted by an admin or by a system account.
    "SYSTEM_DELETED"] = "systemDeleted";
    ContentState[// Awaiting hard deletion.
    "PENDING_PERMANENT_DELETE"] = "pendingPermanentDelete";
})(ContentState || (ContentState = {}));
export var ContentStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "CONTENT_STATE_UNSPECIFIED":
            default:
                return ContentState.UNSPECIFIED;
            case "PENDING_CLASSIFICATION":
                return ContentState.PENDING_CLASSIFICATION;
            case "PUBLISHED":
                return ContentState.PUBLISHED;
            case "TEMPORARILY_QUARANTINED":
                return ContentState.TEMPORARILY_QUARANTINED;
            case "PERMANENTLY_QUARANTINED":
                return ContentState.PERMANENTLY_QUARANTINED;
            case "USER_DELETED":
                return ContentState.USER_DELETED;
            case "SYSTEM_DELETED":
                return ContentState.SYSTEM_DELETED;
            case "PENDING_PERMANENT_DELETE":
                return ContentState.PENDING_PERMANENT_DELETE;
        }
    }
};
export var OrganizationMembershipType;
(function(OrganizationMembershipType) {
    OrganizationMembershipType["UNSPECIFIED"] = "unspecified";
    OrganizationMembershipType[// Regular members of an organization
    "MEMBER"] = "member";
    OrganizationMembershipType[// The owner of an organization
    "OWNER"] = "owner";
})(OrganizationMembershipType || (OrganizationMembershipType = {}));
export var OrganizationMembershipTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "ORGANIZATION_MEMBERSHIP_TYPE_UNSPECIFIED":
            default:
                return OrganizationMembershipType.UNSPECIFIED;
            case "MEMBER":
                return OrganizationMembershipType.MEMBER;
            case "OWNER":
                return OrganizationMembershipType.OWNER;
        }
    }
};
// TODO: Remove V2 after admin/organizations_service is deprecated
export var communityClient = {
    communityService: {
        // Deletes a batch of content owned by the current user with the given IDs
        batchDeleteItems: createClient(BatchDeleteItemsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "community.CommunityService/BatchDeleteItems")
    },
    organizationsV2Service: {
        // This method creates a new organization given some settings
        createV2Organization: createClient(CreateOrganizationRequestWireFormat3, CreateOrganizationResponseWireFormat3, "community.OrganizationsV2Service/CreateV2Organization"),
        // Fetches an organization
        getOrganization: createClient(GetOrganizationRequestWireFormat3, OrganizationWireFormat3, "community.OrganizationsV2Service/GetOrganization")
    }
};
